export class KeycloakError extends Error {
  public mutationVariables: unknown;

  constructor(message: string) {
    super(message);
    this.name = 'KeycloakError';
  }
}
